var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.getBaseClass,
      attrs: {
        injectHiddenInput: _vm.injectHiddenInput,
        injectInputName: _vm.injectInputName,
        isSearchResultLock: _vm.isSearchResultLock,
        isShowSpinner: _vm.isShowSpinner,
      },
    },
    [
      Object.keys(_vm.items).length
        ? [
            _c(
              "ul",
              { staticClass: "tags-search__selected list-unstyled" },
              _vm._l(_vm.items, function (item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass: "tags-search__selected__item",
                    class: _vm.getSelectedItemClass,
                  },
                  [
                    _vm.injectHiddenInput && _vm.injectInputName != ""
                      ? _c("input", {
                          attrs: { type: "hidden", name: _vm.injectInputName },
                          domProps: { value: item.id },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(item.name))]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "tags-search__selected__remove",
                        on: {
                          click: function ($event) {
                            return _vm.onRemove(index)
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "icon-svg",
                            staticStyle: { display: "flex" },
                          },
                          [
                            _c("use", {
                              attrs: { href: _vm.spritePath + "#cross" },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "tags-search__input-wrap",
          class: _vm.getInputWrapClass,
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.query,
                expression: "query",
              },
              {
                name: "click-outside",
                rawName: "v-click-outside",
                value: _vm.onOutside,
                expression: "onOutside",
              },
            ],
            staticClass: "tags-search__input form-control form-control-sm",
            class: _vm.getInputClass,
            attrs: { type: "text", placeholder: _vm.messages.placeholder },
            domProps: { value: _vm.query },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.query = $event.target.value
                },
                _vm.onInput,
              ],
              focus: _vm.onFocus,
            },
          }),
        ]
      ),
      _vm._v(" "),
      Object.keys(_vm.searchItems).length
        ? [
            _c("div", { attrs: { "data-toggle": "dropdown" } }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "tags-search__dd-menu dropdown-menu",
                class: _vm.getDropdownMenuClass,
              },
              _vm._l(_vm.searchItems, function (item, index) {
                return _c(
                  "a",
                  {
                    key: index,
                    staticClass: "dropdown-item",
                    class: _vm.getDropdownItemClass,
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.onSelect(index)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(item.name) +
                        "\n                "
                    ),
                  ]
                )
              }),
              0
            ),
          ]
        : _vm.isShowResult
        ? [
            _c("div", { attrs: { "data-toggle": "dropdown" } }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "tags-search__dd-menu dropdown-menu",
                class: _vm.getDropdownMenuClass,
              },
              [
                _c("div", { staticClass: "p-3" }, [
                  _vm._v(" " + _vm._s(_vm.messages.notFound) + " "),
                ]),
              ]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }